var _defs, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#A7A7A7;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "10.38 29.7 15.1 29.7 12.75 23.65 10.38 29.7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.21,10.84,25.67,1.18A4.59,4.59,0,0,0,22.56,0H6.88A4.2,4.2,0,0,0,2.5,4V36a4.2,4.2,0,0,0,4.35,4H33.13a4.2,4.2,0,0,0,4.37-4V13.66A3.78,3.78,0,0,0,36.21,10.84Zm-16,25.76L18.84,33H11.65L10.22,36.6H6.73L13.53,19h3.4L23.7,36.6ZM24.38,14a2.1,2.1,0,0,1-2.19-2V3l12,11Z",
    transform: "translate(-2.5 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraftIcon);
export default __webpack_public_path__ + "static/media/graft_icon.f1f8987915b83ba38ac6c5de936ac6fb.svg";
export { ForwardRef as ReactComponent };